export default __webpack_public_path__ + "static/media/bro.6757621e.webp";